const COMBINING_MARKS = /[̀-ͯ]/g;
const MAX_SUGGESTION_DISTANCE = 3;

export function normalizeName(value) {
    return String(value ?? '')
        .normalize('NFD')
        .replace(COMBINING_MARKS, '')
        .replace(/œ/gi, 'oe')
        .replace(/æ/gi, 'ae')
        .toLowerCase()
        .replace(/\s+/g, ' ')
        .trim();
}

function editDistance(a, b) {
    const previous = Array.from({length: b.length + 1}, (_, index) => index);
    for (let i = 1; i <= a.length; i++) {
        let diagonal = previous[0];
        previous[0] = i;
        for (let j = 1; j <= b.length; j++) {
            const above = previous[j];
            previous[j] = Math.min(
                previous[j] + 1,
                previous[j - 1] + 1,
                diagonal + (a[i - 1] === b[j - 1] ? 0 : 1),
            );
            diagonal = above;
        }
    }
    return previous[b.length];
}

export function rankByName(value, candidates, nameOf = candidate => candidate) {
    const target = normalizeName(value);
    return candidates
        .map(candidate => ({candidate, distance: editDistance(target, normalizeName(nameOf(candidate)))}))
        .sort((a, b) => a.distance - b.distance);
}

export function isCloseMatch(value, distance) {
    const length = normalizeName(value).length;
    return distance <= Math.min(MAX_SUGGESTION_DISTANCE, Math.max(1, Math.floor(length / 4)));
}
